import { render } from "./SqSelectWithAdd.vue?vue&type=template&id=2c3a0eca"
import script from "./SqSelectWithAdd.vue?vue&type=script&lang=js"
export * from "./SqSelectWithAdd.vue?vue&type=script&lang=js"

import exportComponent from "/builds/flowberry1/flowberry/user-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSelect});
